import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "hooks/storeHooks"
import { selectUserInfo } from "store/user/userSlice"

const MAX_USERNAME_LENGTH = 20

export function DemoUserButton() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userInfo = useAppSelector(selectUserInfo)

  const handleDemoClick = () => {
    navigate("/user-settings")
  }

  const username = userInfo.username || t("nav.demoUser")
  const displayUsername =
    username.length > MAX_USERNAME_LENGTH
      ? `${username.substring(0, MAX_USERNAME_LENGTH)}...`
      : username
  const firstLetter = username.charAt(0).toUpperCase() || "D"

  return (
    <button
      onClick={handleDemoClick}
      className="flex items-center gap-2 px-3 py-2 hover:bg-gray-700 transition-colors focus:outline-none rounded text-left w-full"
    >
      <div className="w-6 h-6 bg-gray-500 rounded-full flex items-center justify-center flex-shrink-0">
        <span className="text-xs text-white font-semibold">{firstLetter}</span>
      </div>
      <span className="text-sm text-white truncate">{displayUsername}</span>
    </button>
  )
}
